export const LOGO_SHOW_REQUEST = "LOGO_SHOW_REQUEST"
export const LOGO_SHOW_SUCCESS = "LOGO_SHOW_SUCCESS"
export const LOGO_SHOW_FAIL = "LOGO_SHOW_FAIL"

export const LOGO_EDIT_REQUEST = "LOGO_EDIT_REQUEST"
export const LOGO_EDIT_SUCCESS = "LOGO_EDIT_SUCCESS"
export const LOGO_EDIT_FAIL = "LOGO_EDIT_FAIL"


export const LOGO_UPDATE_REQUEST = "LOGO_UPDATE_REQUEST"
export const LOGO_UPDATE_SUCCESS = "LOGO_UPDATE_SUCCESS"
export const LOGO_UPDATE_FAIL = "LOGO_UPDATE_FAIL"
export const LOGO_UPDATE_RESET = "LOGO_UPDATE_RESET"